module.exports = require("serve-favicon");